"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DETAILS_MORE_APPS_FETCH = exports.REVIEWS_STATS = exports.REVIEWS_FETCH = exports.REVIEW_WRITE = exports.HUBS = exports.ADMINS = exports.APP_INTEGRATIONS = void 0;
var APP_INTEGRATIONS = 'APP_INTEGRATIONS';
exports.APP_INTEGRATIONS = APP_INTEGRATIONS;
var ADMINS = 'ADMINS';
exports.ADMINS = ADMINS;
var HUBS = 'HUBS';
exports.HUBS = HUBS;
var REVIEW_WRITE = 'REVIEW_WRITE';
exports.REVIEW_WRITE = REVIEW_WRITE;
var REVIEWS_FETCH = 'REVIEWS_FETCH';
exports.REVIEWS_FETCH = REVIEWS_FETCH;
var REVIEWS_STATS = 'REVIEWS_STATS';
exports.REVIEWS_STATS = REVIEWS_STATS;
var DETAILS_MORE_APPS_FETCH = 'DETAILS_MORE_APPS_FETCH';
exports.DETAILS_MORE_APPS_FETCH = DETAILS_MORE_APPS_FETCH;


//////////////////
// WEBPACK FOOTER
// ./js/constants/RequestKey.js
// module id = 240
// module chunks = 209 210 211 212